/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Created.ai API
 * OpenAPI spec version: 1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Brand,
  BrandIn,
  ErrorEnvelope,
  Folder,
  FolderCreate,
  FolderIn,
  FolderMove,
  Invitation,
  InvitationAccept,
  InvitationAccepted,
  InvitationCreate,
  InvitationForYou,
  ListProductsParams,
  Member,
  MemberUpdate,
  MyTeam,
  Product,
  ProductIn,
  ProductSummary,
  Team,
  TeamCreate,
  TeamUpdate
} from '../../model';

import { apiRequest } from '../../../client';
import type { ErrorType } from '../../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListInvitationsForMeUrl = () => {




  return `/api/v1/me/invitations`
}

/**
 * The pending invitations to the caller's verified email, with each team's and inviter's
 * name: "Invitations for you" after sign-in. A session only, never a personal access token.
 * @summary List Invitations For Me
 */
export const listInvitationsForMe = async ( options?: Parameters<typeof apiRequest>[1]): Promise<InvitationForYou[]> => {

  return apiRequest<InvitationForYou[]>(getListInvitationsForMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInvitationsForMeQueryKey = () => {
    return [
    `/api/v1/me/invitations`
    ] as const;
    }


export const getListInvitationsForMeQueryOptions = <TData = Awaited<ReturnType<typeof listInvitationsForMe>>, TError = ErrorType<ErrorEnvelope>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvitationsForMe>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInvitationsForMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvitationsForMe>>> = ({ signal }) => listInvitationsForMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInvitationsForMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInvitationsForMeQueryResult = NonNullable<Awaited<ReturnType<typeof listInvitationsForMe>>>
export type ListInvitationsForMeQueryError = ErrorType<ErrorEnvelope>


export function useListInvitationsForMe<TData = Awaited<ReturnType<typeof listInvitationsForMe>>, TError = ErrorType<ErrorEnvelope>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvitationsForMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInvitationsForMe>>,
          TError,
          Awaited<ReturnType<typeof listInvitationsForMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInvitationsForMe<TData = Awaited<ReturnType<typeof listInvitationsForMe>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvitationsForMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInvitationsForMe>>,
          TError,
          Awaited<ReturnType<typeof listInvitationsForMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInvitationsForMe<TData = Awaited<ReturnType<typeof listInvitationsForMe>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvitationsForMe>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Invitations For Me
 */

export function useListInvitationsForMe<TData = Awaited<ReturnType<typeof listInvitationsForMe>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvitationsForMe>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInvitationsForMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAcceptInvitationUrl = () => {




  return `/api/v1/me/invitations/accept`
}

/**
 * Join the team of the invitation in the email link, as the email it was sent to.
 * @summary Accept Invitation
 */
export const acceptInvitation = async (invitationAccept: InvitationAccept, options?: Parameters<typeof apiRequest>[1]): Promise<InvitationAccepted> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<InvitationAccepted>(getAcceptInvitationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(invitationAccept)
  }
);}





export const getAcceptInvitationMutationKey = () => ['acceptInvitation'] as const;

export const getAcceptInvitationMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInvitation>>, TError,AcceptInvitationMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptInvitation>>, TError,AcceptInvitationMutationVariables, TContext> => {

const mutationKey = getAcceptInvitationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptInvitation>>, AcceptInvitationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  acceptInvitation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof acceptInvitation>>>
    export type AcceptInvitationMutationBody = InvitationAccept
    export type AcceptInvitationMutationError = ErrorType<ErrorEnvelope>
    export type AcceptInvitationMutationVariables = {data: InvitationAccept}

    /**
 * @summary Accept Invitation
 */
export const useAcceptInvitation = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInvitation>>, TError,AcceptInvitationMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptInvitation>>,
        TError,
        AcceptInvitationMutationVariables,
        TContext
      > => {
      return useMutation(getAcceptInvitationMutationOptions(options), queryClient);
    }
    export const getAcceptInvitationForMeUrl = (invitationId: string,) => {




  return `/api/v1/me/invitations/${invitationId}/accept`
}

/**
 * Join the team of one of "Invitations for you", as the email it was sent to: the token
 * accept's rules, the invitation found by id. Another email's is 404.
 * @summary Accept Invitation For Me
 */
export const acceptInvitationForMe = async (invitationId: string, options?: Parameters<typeof apiRequest>[1]): Promise<InvitationAccepted> => {

  return apiRequest<InvitationAccepted>(getAcceptInvitationForMeUrl(invitationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAcceptInvitationForMeMutationKey = () => ['acceptInvitationForMe'] as const;

export const getAcceptInvitationForMeMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInvitationForMe>>, TError,AcceptInvitationForMeMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptInvitationForMe>>, TError,AcceptInvitationForMeMutationVariables, TContext> => {

const mutationKey = getAcceptInvitationForMeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptInvitationForMe>>, AcceptInvitationForMeMutationVariables> = (props) => {
          const {invitationId} = props ?? {};

          return  acceptInvitationForMe(invitationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptInvitationForMeMutationResult = NonNullable<Awaited<ReturnType<typeof acceptInvitationForMe>>>

    export type AcceptInvitationForMeMutationError = ErrorType<ErrorEnvelope>
    export type AcceptInvitationForMeMutationVariables = {invitationId: string}

    /**
 * @summary Accept Invitation For Me
 */
export const useAcceptInvitationForMe = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInvitationForMe>>, TError,AcceptInvitationForMeMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptInvitationForMe>>,
        TError,
        AcceptInvitationForMeMutationVariables,
        TContext
      > => {
      return useMutation(getAcceptInvitationForMeMutationOptions(options), queryClient);
    }
    export const getListMyTeamsUrl = () => {




  return `/api/v1/me/teams`
}

/**
 * The caller's teams and their role in each.
 * @summary List My Teams
 */
export const listMyTeams = async ( options?: Parameters<typeof apiRequest>[1]): Promise<MyTeam[]> => {

  return apiRequest<MyTeam[]>(getListMyTeamsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMyTeamsQueryKey = () => {
    return [
    `/api/v1/me/teams`
    ] as const;
    }


export const getListMyTeamsQueryOptions = <TData = Awaited<ReturnType<typeof listMyTeams>>, TError = ErrorType<ErrorEnvelope>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyTeams>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyTeamsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyTeams>>> = ({ signal }) => listMyTeams({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyTeams>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMyTeamsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyTeams>>>
export type ListMyTeamsQueryError = ErrorType<ErrorEnvelope>


export function useListMyTeams<TData = Awaited<ReturnType<typeof listMyTeams>>, TError = ErrorType<ErrorEnvelope>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyTeams>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyTeams>>,
          TError,
          Awaited<ReturnType<typeof listMyTeams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyTeams<TData = Awaited<ReturnType<typeof listMyTeams>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyTeams>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyTeams>>,
          TError,
          Awaited<ReturnType<typeof listMyTeams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyTeams<TData = Awaited<ReturnType<typeof listMyTeams>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyTeams>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List My Teams
 */

export function useListMyTeams<TData = Awaited<ReturnType<typeof listMyTeams>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyTeams>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyTeamsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateMyTeamUrl = () => {




  return `/api/v1/me/teams`
}

/**
 * A team the caller owns. Self-serve only: with the flag off, staff create teams (D1).
 * @summary Create My Team
 */
export const createMyTeam = async (teamCreate: TeamCreate, options?: Parameters<typeof apiRequest>[1]): Promise<Team> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<Team>(getCreateMyTeamUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(teamCreate)
  }
);}





export const getCreateMyTeamMutationKey = () => ['createMyTeam'] as const;

export const getCreateMyTeamMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMyTeam>>, TError,CreateMyTeamMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof createMyTeam>>, TError,CreateMyTeamMutationVariables, TContext> => {

const mutationKey = getCreateMyTeamMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMyTeam>>, CreateMyTeamMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createMyTeam(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMyTeamMutationResult = NonNullable<Awaited<ReturnType<typeof createMyTeam>>>
    export type CreateMyTeamMutationBody = TeamCreate
    export type CreateMyTeamMutationError = ErrorType<ErrorEnvelope>
    export type CreateMyTeamMutationVariables = {data: TeamCreate}

    /**
 * @summary Create My Team
 */
export const useCreateMyTeam = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMyTeam>>, TError,CreateMyTeamMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createMyTeam>>,
        TError,
        CreateMyTeamMutationVariables,
        TContext
      > => {
      return useMutation(getCreateMyTeamMutationOptions(options), queryClient);
    }
    export const getDeleteTeamUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}`
}

/**
 * Delete the team (the owner only). Its jobs that have not delivered are canceled.
 * @summary Delete Team
 */
export const deleteTeam = async (teamId: string, options?: Parameters<typeof apiRequest>[1]): Promise<void> => {

  return apiRequest<void>(getDeleteTeamUrl(teamId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTeamMutationKey = () => ['deleteTeam'] as const;

export const getDeleteTeamMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeam>>, TError,DeleteTeamMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTeam>>, TError,DeleteTeamMutationVariables, TContext> => {

const mutationKey = getDeleteTeamMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTeam>>, DeleteTeamMutationVariables> = (props) => {
          const {teamId} = props ?? {};

          return  deleteTeam(teamId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTeamMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTeam>>>

    export type DeleteTeamMutationError = ErrorType<ErrorEnvelope>
    export type DeleteTeamMutationVariables = {teamId: string}

    /**
 * @summary Delete Team
 */
export const useDeleteTeam = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeam>>, TError,DeleteTeamMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTeam>>,
        TError,
        DeleteTeamMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteTeamMutationOptions(options), queryClient);
    }
    export const getGetTeamUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}`
}

/**
 * @summary Get Team
 */
export const getTeam = async (teamId: string, options?: Parameters<typeof apiRequest>[1]): Promise<Team> => {

  return apiRequest<Team>(getGetTeamUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTeamQueryKey = (teamId: string,) => {
    return [
    `/api/v1/teams/${teamId}`
    ] as const;
    }


export const getGetTeamQueryOptions = <TData = Awaited<ReturnType<typeof getTeam>>, TError = ErrorType<ErrorEnvelope>>(teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeam>>> = ({ signal }) => getTeam(teamId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamQueryResult = NonNullable<Awaited<ReturnType<typeof getTeam>>>
export type GetTeamQueryError = ErrorType<ErrorEnvelope>


export function useGetTeam<TData = Awaited<ReturnType<typeof getTeam>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeam>>,
          TError,
          Awaited<ReturnType<typeof getTeam>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeam<TData = Awaited<ReturnType<typeof getTeam>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeam>>,
          TError,
          Awaited<ReturnType<typeof getTeam>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeam<TData = Awaited<ReturnType<typeof getTeam>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Team
 */

export function useGetTeam<TData = Awaited<ReturnType<typeof getTeam>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRenameTeamUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}`
}

/**
 * A new name for the team (admins and the owner).
 * @summary Rename Team
 */
export const renameTeam = async (teamId: string,
    teamUpdate: TeamUpdate, options?: Parameters<typeof apiRequest>[1]): Promise<Team> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<Team>(getRenameTeamUrl(teamId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(teamUpdate)
  }
);}





export const getRenameTeamMutationKey = () => ['renameTeam'] as const;

export const getRenameTeamMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameTeam>>, TError,RenameTeamMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof renameTeam>>, TError,RenameTeamMutationVariables, TContext> => {

const mutationKey = getRenameTeamMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof renameTeam>>, RenameTeamMutationVariables> = (props) => {
          const {teamId,data} = props ?? {};

          return  renameTeam(teamId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RenameTeamMutationResult = NonNullable<Awaited<ReturnType<typeof renameTeam>>>
    export type RenameTeamMutationBody = TeamUpdate
    export type RenameTeamMutationError = ErrorType<ErrorEnvelope>
    export type RenameTeamMutationVariables = {teamId: string;data: TeamUpdate}

    /**
 * @summary Rename Team
 */
export const useRenameTeam = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameTeam>>, TError,RenameTeamMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof renameTeam>>,
        TError,
        RenameTeamMutationVariables,
        TContext
      > => {
      return useMutation(getRenameTeamMutationOptions(options), queryClient);
    }
    export const getListBrandsUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}/brands`
}

/**
 * The team's live brands, by name, for every member (D6).
 * @summary List Brands
 */
export const listBrands = async (teamId: string, options?: Parameters<typeof apiRequest>[1]): Promise<Brand[]> => {

  return apiRequest<Brand[]>(getListBrandsUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBrandsQueryKey = (teamId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands`
    ] as const;
    }


export const getListBrandsQueryOptions = <TData = Awaited<ReturnType<typeof listBrands>>, TError = ErrorType<ErrorEnvelope>>(teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBrandsQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBrands>>> = ({ signal }) => listBrands(teamId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListBrandsQueryResult = NonNullable<Awaited<ReturnType<typeof listBrands>>>
export type ListBrandsQueryError = ErrorType<ErrorEnvelope>


export function useListBrands<TData = Awaited<ReturnType<typeof listBrands>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBrands>>,
          TError,
          Awaited<ReturnType<typeof listBrands>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBrands<TData = Awaited<ReturnType<typeof listBrands>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBrands>>,
          TError,
          Awaited<ReturnType<typeof listBrands>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBrands<TData = Awaited<ReturnType<typeof listBrands>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Brands
 */

export function useListBrands<TData = Awaited<ReturnType<typeof listBrands>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBrands>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListBrandsQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateBrandUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}/brands`
}

/**
 * A new brand. When its first font is a Google font, its typography is classified after the
 * save.
 * @summary Create Brand
 */
export const createBrand = async (teamId: string,
    brandIn: BrandIn, options?: Parameters<typeof apiRequest>[1]): Promise<Brand> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<Brand>(getCreateBrandUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(brandIn)
  }
);}





export const getCreateBrandMutationKey = () => ['createBrand'] as const;

export const getCreateBrandMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBrand>>, TError,CreateBrandMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof createBrand>>, TError,CreateBrandMutationVariables, TContext> => {

const mutationKey = getCreateBrandMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBrand>>, CreateBrandMutationVariables> = (props) => {
          const {teamId,data} = props ?? {};

          return  createBrand(teamId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBrandMutationResult = NonNullable<Awaited<ReturnType<typeof createBrand>>>
    export type CreateBrandMutationBody = BrandIn
    export type CreateBrandMutationError = ErrorType<ErrorEnvelope>
    export type CreateBrandMutationVariables = {teamId: string;data: BrandIn}

    /**
 * @summary Create Brand
 */
export const useCreateBrand = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBrand>>, TError,CreateBrandMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBrand>>,
        TError,
        CreateBrandMutationVariables,
        TContext
      > => {
      return useMutation(getCreateBrandMutationOptions(options), queryClient);
    }
    export const getDeleteBrandUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}`
}

/**
 * @summary Delete Brand
 */
export const deleteBrand = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<void> => {

  return apiRequest<void>(getDeleteBrandUrl(teamId,brandId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteBrandMutationKey = () => ['deleteBrand'] as const;

export const getDeleteBrandMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBrand>>, TError,DeleteBrandMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBrand>>, TError,DeleteBrandMutationVariables, TContext> => {

const mutationKey = getDeleteBrandMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBrand>>, DeleteBrandMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  deleteBrand(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteBrandMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBrand>>>

    export type DeleteBrandMutationError = ErrorType<ErrorEnvelope>
    export type DeleteBrandMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Delete Brand
 */
export const useDeleteBrand = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBrand>>, TError,DeleteBrandMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBrand>>,
        TError,
        DeleteBrandMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteBrandMutationOptions(options), queryClient);
    }
    export const getGetBrandUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}`
}

/**
 * @summary Get Brand
 */
export const getBrand = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<Brand> => {

  return apiRequest<Brand>(getGetBrandUrl(teamId,brandId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBrandQueryKey = (teamId: string,
    brandId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}`
    ] as const;
    }


export const getGetBrandQueryOptions = <TData = Awaited<ReturnType<typeof getBrand>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrand>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrandQueryKey(teamId,brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrand>>> = ({ signal }) => getBrand(teamId,brandId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrand>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrandQueryResult = NonNullable<Awaited<ReturnType<typeof getBrand>>>
export type GetBrandQueryError = ErrorType<ErrorEnvelope>


export function useGetBrand<TData = Awaited<ReturnType<typeof getBrand>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrand>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrand>>,
          TError,
          Awaited<ReturnType<typeof getBrand>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrand<TData = Awaited<ReturnType<typeof getBrand>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrand>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrand>>,
          TError,
          Awaited<ReturnType<typeof getBrand>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrand<TData = Awaited<ReturnType<typeof getBrand>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrand>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Brand
 */

export function useGetBrand<TData = Awaited<ReturnType<typeof getBrand>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrand>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrandQueryOptions(teamId,brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getReplaceBrandUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}`
}

/**
 * Replace the whole brand with the request.
 * @summary Replace Brand
 */
export const replaceBrand = async (teamId: string,
    brandId: string,
    brandIn: BrandIn, options?: Parameters<typeof apiRequest>[1]): Promise<Brand> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<Brand>(getReplaceBrandUrl(teamId,brandId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(brandIn)
  }
);}





export const getReplaceBrandMutationKey = () => ['replaceBrand'] as const;

export const getReplaceBrandMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceBrand>>, TError,ReplaceBrandMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof replaceBrand>>, TError,ReplaceBrandMutationVariables, TContext> => {

const mutationKey = getReplaceBrandMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceBrand>>, ReplaceBrandMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  replaceBrand(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplaceBrandMutationResult = NonNullable<Awaited<ReturnType<typeof replaceBrand>>>
    export type ReplaceBrandMutationBody = BrandIn
    export type ReplaceBrandMutationError = ErrorType<ErrorEnvelope>
    export type ReplaceBrandMutationVariables = {teamId: string;brandId: string;data: BrandIn}

    /**
 * @summary Replace Brand
 */
export const useReplaceBrand = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceBrand>>, TError,ReplaceBrandMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceBrand>>,
        TError,
        ReplaceBrandMutationVariables,
        TContext
      > => {
      return useMutation(getReplaceBrandMutationOptions(options), queryClient);
    }
    export const getListFoldersUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/folders`
}

/**
 * The brand's folders, by name, each with its `parent_id` (null at the top level; the
 * client builds the tree) and marked if the caller made it a favorite.
 * @summary List Folders
 */
export const listFolders = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<Folder[]> => {

  return apiRequest<Folder[]>(getListFoldersUrl(teamId,brandId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListFoldersQueryKey = (teamId: string,
    brandId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/folders`
    ] as const;
    }


export const getListFoldersQueryOptions = <TData = Awaited<ReturnType<typeof listFolders>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFolders>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFoldersQueryKey(teamId,brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFolders>>> = ({ signal }) => listFolders(teamId,brandId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFolders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListFoldersQueryResult = NonNullable<Awaited<ReturnType<typeof listFolders>>>
export type ListFoldersQueryError = ErrorType<ErrorEnvelope>


export function useListFolders<TData = Awaited<ReturnType<typeof listFolders>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFolders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFolders>>,
          TError,
          Awaited<ReturnType<typeof listFolders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListFolders<TData = Awaited<ReturnType<typeof listFolders>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFolders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFolders>>,
          TError,
          Awaited<ReturnType<typeof listFolders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListFolders<TData = Awaited<ReturnType<typeof listFolders>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFolders>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Folders
 */

export function useListFolders<TData = Awaited<ReturnType<typeof listFolders>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFolders>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListFoldersQueryOptions(teamId,brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateFolderUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/folders`
}

/**
 * A folder at the brand's top level, or in `parent_id` (422 when not one of the brand's).
 * Its name is unique among its siblings (409).
 * @summary Create Folder
 */
export const createFolder = async (teamId: string,
    brandId: string,
    folderCreate: FolderCreate, options?: Parameters<typeof apiRequest>[1]): Promise<Folder> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<Folder>(getCreateFolderUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(folderCreate)
  }
);}





export const getCreateFolderMutationKey = () => ['createFolder'] as const;

export const getCreateFolderMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFolder>>, TError,CreateFolderMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof createFolder>>, TError,CreateFolderMutationVariables, TContext> => {

const mutationKey = getCreateFolderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFolder>>, CreateFolderMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  createFolder(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFolderMutationResult = NonNullable<Awaited<ReturnType<typeof createFolder>>>
    export type CreateFolderMutationBody = FolderCreate
    export type CreateFolderMutationError = ErrorType<ErrorEnvelope>
    export type CreateFolderMutationVariables = {teamId: string;brandId: string;data: FolderCreate}

    /**
 * @summary Create Folder
 */
export const useCreateFolder = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFolder>>, TError,CreateFolderMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createFolder>>,
        TError,
        CreateFolderMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFolderMutationOptions(options), queryClient);
    }
    export const getRenameFolderUrl = (teamId: string,
    brandId: string,
    folderId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/folders/${folderId}`
}

/**
 * Rename a folder: its creator or an admin (D6).
 * @summary Rename Folder
 */
export const renameFolder = async (teamId: string,
    brandId: string,
    folderId: string,
    folderIn: FolderIn, options?: Parameters<typeof apiRequest>[1]): Promise<Folder> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<Folder>(getRenameFolderUrl(teamId,brandId,folderId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(folderIn)
  }
);}





export const getRenameFolderMutationKey = () => ['renameFolder'] as const;

export const getRenameFolderMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameFolder>>, TError,RenameFolderMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof renameFolder>>, TError,RenameFolderMutationVariables, TContext> => {

const mutationKey = getRenameFolderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof renameFolder>>, RenameFolderMutationVariables> = (props) => {
          const {teamId,brandId,folderId,data} = props ?? {};

          return  renameFolder(teamId,brandId,folderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RenameFolderMutationResult = NonNullable<Awaited<ReturnType<typeof renameFolder>>>
    export type RenameFolderMutationBody = FolderIn
    export type RenameFolderMutationError = ErrorType<ErrorEnvelope>
    export type RenameFolderMutationVariables = {teamId: string;brandId: string;folderId: string;data: FolderIn}

    /**
 * @summary Rename Folder
 */
export const useRenameFolder = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameFolder>>, TError,RenameFolderMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof renameFolder>>,
        TError,
        RenameFolderMutationVariables,
        TContext
      > => {
      return useMutation(getRenameFolderMutationOptions(options), queryClient);
    }
    export const getRemoveFolderFavoriteUrl = (teamId: string,
    brandId: string,
    folderId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/folders/${folderId}/favorite`
}

/**
 * @summary Remove Folder Favorite
 */
export const removeFolderFavorite = async (teamId: string,
    brandId: string,
    folderId: string, options?: Parameters<typeof apiRequest>[1]): Promise<void> => {

  return apiRequest<void>(getRemoveFolderFavoriteUrl(teamId,brandId,folderId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveFolderFavoriteMutationKey = () => ['removeFolderFavorite'] as const;

export const getRemoveFolderFavoriteMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeFolderFavorite>>, TError,RemoveFolderFavoriteMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof removeFolderFavorite>>, TError,RemoveFolderFavoriteMutationVariables, TContext> => {

const mutationKey = getRemoveFolderFavoriteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeFolderFavorite>>, RemoveFolderFavoriteMutationVariables> = (props) => {
          const {teamId,brandId,folderId} = props ?? {};

          return  removeFolderFavorite(teamId,brandId,folderId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveFolderFavoriteMutationResult = NonNullable<Awaited<ReturnType<typeof removeFolderFavorite>>>

    export type RemoveFolderFavoriteMutationError = ErrorType<ErrorEnvelope>
    export type RemoveFolderFavoriteMutationVariables = {teamId: string;brandId: string;folderId: string}

    /**
 * @summary Remove Folder Favorite
 */
export const useRemoveFolderFavorite = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeFolderFavorite>>, TError,RemoveFolderFavoriteMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeFolderFavorite>>,
        TError,
        RemoveFolderFavoriteMutationVariables,
        TContext
      > => {
      return useMutation(getRemoveFolderFavoriteMutationOptions(options), queryClient);
    }
    export const getAddFolderFavoriteUrl = (teamId: string,
    brandId: string,
    folderId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/folders/${folderId}/favorite`
}

/**
 * Mark the folder a favorite of the caller; doing it twice is the same.
 * @summary Add Folder Favorite
 */
export const addFolderFavorite = async (teamId: string,
    brandId: string,
    folderId: string, options?: Parameters<typeof apiRequest>[1]): Promise<void> => {

  return apiRequest<void>(getAddFolderFavoriteUrl(teamId,brandId,folderId),
  {
    ...options,
    method: 'PUT'


  }
);}





export const getAddFolderFavoriteMutationKey = () => ['addFolderFavorite'] as const;

export const getAddFolderFavoriteMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFolderFavorite>>, TError,AddFolderFavoriteMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof addFolderFavorite>>, TError,AddFolderFavoriteMutationVariables, TContext> => {

const mutationKey = getAddFolderFavoriteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addFolderFavorite>>, AddFolderFavoriteMutationVariables> = (props) => {
          const {teamId,brandId,folderId} = props ?? {};

          return  addFolderFavorite(teamId,brandId,folderId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddFolderFavoriteMutationResult = NonNullable<Awaited<ReturnType<typeof addFolderFavorite>>>

    export type AddFolderFavoriteMutationError = ErrorType<ErrorEnvelope>
    export type AddFolderFavoriteMutationVariables = {teamId: string;brandId: string;folderId: string}

    /**
 * @summary Add Folder Favorite
 */
export const useAddFolderFavorite = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFolderFavorite>>, TError,AddFolderFavoriteMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addFolderFavorite>>,
        TError,
        AddFolderFavoriteMutationVariables,
        TContext
      > => {
      return useMutation(getAddFolderFavoriteMutationOptions(options), queryClient);
    }
    export const getMoveFolderUrl = (teamId: string,
    brandId: string,
    folderId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/folders/${folderId}/move`
}

/**
 * Move a folder and everything under it into `parent_id`, or to the top level with null
 * (its creator or an admin). 422 into itself, a folder under it or a folder that is not the
 * brand's; 409 when the new siblings have its name.
 * @summary Move Folder
 */
export const moveFolder = async (teamId: string,
    brandId: string,
    folderId: string,
    folderMove: FolderMove, options?: Parameters<typeof apiRequest>[1]): Promise<Folder> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<Folder>(getMoveFolderUrl(teamId,brandId,folderId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(folderMove)
  }
);}





export const getMoveFolderMutationKey = () => ['moveFolder'] as const;

export const getMoveFolderMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveFolder>>, TError,MoveFolderMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof moveFolder>>, TError,MoveFolderMutationVariables, TContext> => {

const mutationKey = getMoveFolderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveFolder>>, MoveFolderMutationVariables> = (props) => {
          const {teamId,brandId,folderId,data} = props ?? {};

          return  moveFolder(teamId,brandId,folderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MoveFolderMutationResult = NonNullable<Awaited<ReturnType<typeof moveFolder>>>
    export type MoveFolderMutationBody = FolderMove
    export type MoveFolderMutationError = ErrorType<ErrorEnvelope>
    export type MoveFolderMutationVariables = {teamId: string;brandId: string;folderId: string;data: FolderMove}

    /**
 * @summary Move Folder
 */
export const useMoveFolder = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveFolder>>, TError,MoveFolderMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof moveFolder>>,
        TError,
        MoveFolderMutationVariables,
        TContext
      > => {
      return useMutation(getMoveFolderMutationOptions(options), queryClient);
    }
    export const getListProductsUrl = (teamId: string,
    brandId: string,
    params?: ListProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["created_by"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/teams/${teamId}/brands/${brandId}/products?${stringifiedParams}` : `/api/v1/teams/${teamId}/brands/${brandId}/products`
}

/**
 * The brand's live products, for every member (D6), by name unless `order` says otherwise:
 * live's `newest`, `oldest`, `a_to_z`, `z_to_a` and `most_popular` (the products the team's
 * generations showed most). `created_by` keeps those any of these members made (repeatable).
 * @summary List Products
 */
export const listProducts = async (teamId: string,
    brandId: string,
    params?: ListProductsParams, options?: Parameters<typeof apiRequest>[1]): Promise<Product[]> => {

  return apiRequest<Product[]>(getListProductsUrl(teamId,brandId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProductsQueryKey = (teamId: string,
    brandId: string,
    params?: ListProductsParams,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/products`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProductsQueryOptions = <TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string,
    params?: ListProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProductsQueryKey(teamId,brandId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProducts>>> = ({ signal }) => listProducts(teamId,brandId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listProducts>>>
export type ListProductsQueryError = ErrorType<ErrorEnvelope>


export function useListProducts<TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params: undefined |  ListProductsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProducts>>,
          TError,
          Awaited<ReturnType<typeof listProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProducts<TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params?: ListProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProducts>>,
          TError,
          Awaited<ReturnType<typeof listProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProducts<TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params?: ListProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Products
 */

export function useListProducts<TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params?: ListProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProductsQueryOptions(teamId,brandId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateProductUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/products`
}

/**
 * @summary Create Product
 */
export const createProduct = async (teamId: string,
    brandId: string,
    productIn: ProductIn, options?: Parameters<typeof apiRequest>[1]): Promise<Product> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<Product>(getCreateProductUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(productIn)
  }
);}





export const getCreateProductMutationKey = () => ['createProduct'] as const;

export const getCreateProductMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,CreateProductMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,CreateProductMutationVariables, TContext> => {

const mutationKey = getCreateProductMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProduct>>, CreateProductMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  createProduct(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProductMutationResult = NonNullable<Awaited<ReturnType<typeof createProduct>>>
    export type CreateProductMutationBody = ProductIn
    export type CreateProductMutationError = ErrorType<ErrorEnvelope>
    export type CreateProductMutationVariables = {teamId: string;brandId: string;data: ProductIn}

    /**
 * @summary Create Product
 */
export const useCreateProduct = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,CreateProductMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProduct>>,
        TError,
        CreateProductMutationVariables,
        TContext
      > => {
      return useMutation(getCreateProductMutationOptions(options), queryClient);
    }
    export const getDeleteProductUrl = (teamId: string,
    brandId: string,
    productId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/products/${productId}`
}

/**
 * @summary Delete Product
 */
export const deleteProduct = async (teamId: string,
    brandId: string,
    productId: string, options?: Parameters<typeof apiRequest>[1]): Promise<void> => {

  return apiRequest<void>(getDeleteProductUrl(teamId,brandId,productId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteProductMutationKey = () => ['deleteProduct'] as const;

export const getDeleteProductMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProduct>>, TError,DeleteProductMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProduct>>, TError,DeleteProductMutationVariables, TContext> => {

const mutationKey = getDeleteProductMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProduct>>, DeleteProductMutationVariables> = (props) => {
          const {teamId,brandId,productId} = props ?? {};

          return  deleteProduct(teamId,brandId,productId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProduct>>>

    export type DeleteProductMutationError = ErrorType<ErrorEnvelope>
    export type DeleteProductMutationVariables = {teamId: string;brandId: string;productId: string}

    /**
 * @summary Delete Product
 */
export const useDeleteProduct = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProduct>>, TError,DeleteProductMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProduct>>,
        TError,
        DeleteProductMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteProductMutationOptions(options), queryClient);
    }
    export const getGetProductUrl = (teamId: string,
    brandId: string,
    productId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/products/${productId}`
}

/**
 * @summary Get Product
 */
export const getProduct = async (teamId: string,
    brandId: string,
    productId: string, options?: Parameters<typeof apiRequest>[1]): Promise<Product> => {

  return apiRequest<Product>(getGetProductUrl(teamId,brandId,productId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProductQueryKey = (teamId: string,
    brandId: string,
    productId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/products/${productId}`
    ] as const;
    }


export const getGetProductQueryOptions = <TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string,
    productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductQueryKey(teamId,brandId,productId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProduct>>> = ({ signal }) => getProduct(teamId,brandId,productId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined && productId !== null && productId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductQueryResult = NonNullable<Awaited<ReturnType<typeof getProduct>>>
export type GetProductQueryError = ErrorType<ErrorEnvelope>


export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    productId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProduct>>,
          TError,
          Awaited<ReturnType<typeof getProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProduct>>,
          TError,
          Awaited<ReturnType<typeof getProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Product
 */

export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductQueryOptions(teamId,brandId,productId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getReplaceProductUrl = (teamId: string,
    brandId: string,
    productId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/products/${productId}`
}

/**
 * Replace the whole product with the request.
 * @summary Replace Product
 */
export const replaceProduct = async (teamId: string,
    brandId: string,
    productId: string,
    productIn: ProductIn, options?: Parameters<typeof apiRequest>[1]): Promise<Product> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<Product>(getReplaceProductUrl(teamId,brandId,productId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(productIn)
  }
);}





export const getReplaceProductMutationKey = () => ['replaceProduct'] as const;

export const getReplaceProductMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceProduct>>, TError,ReplaceProductMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof replaceProduct>>, TError,ReplaceProductMutationVariables, TContext> => {

const mutationKey = getReplaceProductMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceProduct>>, ReplaceProductMutationVariables> = (props) => {
          const {teamId,brandId,productId,data} = props ?? {};

          return  replaceProduct(teamId,brandId,productId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplaceProductMutationResult = NonNullable<Awaited<ReturnType<typeof replaceProduct>>>
    export type ReplaceProductMutationBody = ProductIn
    export type ReplaceProductMutationError = ErrorType<ErrorEnvelope>
    export type ReplaceProductMutationVariables = {teamId: string;brandId: string;productId: string;data: ProductIn}

    /**
 * @summary Replace Product
 */
export const useReplaceProduct = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceProduct>>, TError,ReplaceProductMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceProduct>>,
        TError,
        ReplaceProductMutationVariables,
        TContext
      > => {
      return useMutation(getReplaceProductMutationOptions(options), queryClient);
    }
    export const getListInvitationsUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}/invitations`
}

/**
 * @summary List Invitations
 */
export const listInvitations = async (teamId: string, options?: Parameters<typeof apiRequest>[1]): Promise<Invitation[]> => {

  return apiRequest<Invitation[]>(getListInvitationsUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInvitationsQueryKey = (teamId: string,) => {
    return [
    `/api/v1/teams/${teamId}/invitations`
    ] as const;
    }


export const getListInvitationsQueryOptions = <TData = Awaited<ReturnType<typeof listInvitations>>, TError = ErrorType<ErrorEnvelope>>(teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvitations>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInvitationsQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvitations>>> = ({ signal }) => listInvitations(teamId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInvitations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof listInvitations>>>
export type ListInvitationsQueryError = ErrorType<ErrorEnvelope>


export function useListInvitations<TData = Awaited<ReturnType<typeof listInvitations>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvitations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInvitations>>,
          TError,
          Awaited<ReturnType<typeof listInvitations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInvitations<TData = Awaited<ReturnType<typeof listInvitations>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvitations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInvitations>>,
          TError,
          Awaited<ReturnType<typeof listInvitations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInvitations<TData = Awaited<ReturnType<typeof listInvitations>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvitations>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Invitations
 */

export function useListInvitations<TData = Awaited<ReturnType<typeof listInvitations>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvitations>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInvitationsQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateInvitationUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}/invitations`
}

/**
 * Invite an email with a role; the token goes only into the email. 503 `EMAIL_UNAVAILABLE`:
 * the invitation is made but its email could not be sent, so resend it.
 * @summary Create Invitation
 */
export const createInvitation = async (teamId: string,
    invitationCreate: InvitationCreate, options?: Parameters<typeof apiRequest>[1]): Promise<Invitation> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<Invitation>(getCreateInvitationUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(invitationCreate)
  }
);}





export const getCreateInvitationMutationKey = () => ['createInvitation'] as const;

export const getCreateInvitationMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvitation>>, TError,CreateInvitationMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof createInvitation>>, TError,CreateInvitationMutationVariables, TContext> => {

const mutationKey = getCreateInvitationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInvitation>>, CreateInvitationMutationVariables> = (props) => {
          const {teamId,data} = props ?? {};

          return  createInvitation(teamId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof createInvitation>>>
    export type CreateInvitationMutationBody = InvitationCreate
    export type CreateInvitationMutationError = ErrorType<ErrorEnvelope>
    export type CreateInvitationMutationVariables = {teamId: string;data: InvitationCreate}

    /**
 * @summary Create Invitation
 */
export const useCreateInvitation = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvitation>>, TError,CreateInvitationMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createInvitation>>,
        TError,
        CreateInvitationMutationVariables,
        TContext
      > => {
      return useMutation(getCreateInvitationMutationOptions(options), queryClient);
    }
    export const getRevokeInvitationUrl = (teamId: string,
    invitationId: string,) => {




  return `/api/v1/teams/${teamId}/invitations/${invitationId}`
}

/**
 * @summary Revoke Invitation
 */
export const revokeInvitation = async (teamId: string,
    invitationId: string, options?: Parameters<typeof apiRequest>[1]): Promise<void> => {

  return apiRequest<void>(getRevokeInvitationUrl(teamId,invitationId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRevokeInvitationMutationKey = () => ['revokeInvitation'] as const;

export const getRevokeInvitationMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeInvitation>>, TError,RevokeInvitationMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeInvitation>>, TError,RevokeInvitationMutationVariables, TContext> => {

const mutationKey = getRevokeInvitationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeInvitation>>, RevokeInvitationMutationVariables> = (props) => {
          const {teamId,invitationId} = props ?? {};

          return  revokeInvitation(teamId,invitationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof revokeInvitation>>>

    export type RevokeInvitationMutationError = ErrorType<ErrorEnvelope>
    export type RevokeInvitationMutationVariables = {teamId: string;invitationId: string}

    /**
 * @summary Revoke Invitation
 */
export const useRevokeInvitation = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeInvitation>>, TError,RevokeInvitationMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeInvitation>>,
        TError,
        RevokeInvitationMutationVariables,
        TContext
      > => {
      return useMutation(getRevokeInvitationMutationOptions(options), queryClient);
    }
    export const getResendInvitationUrl = (teamId: string,
    invitationId: string,) => {




  return `/api/v1/teams/${teamId}/invitations/${invitationId}/resend`
}

/**
 * A new token and expiry in a new email; the old link stops working. 503
 * `EMAIL_UNAVAILABLE`: the new invitation is made but its email could not be sent.
 * @summary Resend Invitation
 */
export const resendInvitation = async (teamId: string,
    invitationId: string, options?: Parameters<typeof apiRequest>[1]): Promise<Invitation> => {

  return apiRequest<Invitation>(getResendInvitationUrl(teamId,invitationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResendInvitationMutationKey = () => ['resendInvitation'] as const;

export const getResendInvitationMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendInvitation>>, TError,ResendInvitationMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof resendInvitation>>, TError,ResendInvitationMutationVariables, TContext> => {

const mutationKey = getResendInvitationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendInvitation>>, ResendInvitationMutationVariables> = (props) => {
          const {teamId,invitationId} = props ?? {};

          return  resendInvitation(teamId,invitationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof resendInvitation>>>

    export type ResendInvitationMutationError = ErrorType<ErrorEnvelope>
    export type ResendInvitationMutationVariables = {teamId: string;invitationId: string}

    /**
 * @summary Resend Invitation
 */
export const useResendInvitation = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendInvitation>>, TError,ResendInvitationMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resendInvitation>>,
        TError,
        ResendInvitationMutationVariables,
        TContext
      > => {
      return useMutation(getResendInvitationMutationOptions(options), queryClient);
    }
    export const getListMembersUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}/members`
}

/**
 * Every member of the team, for every member (D6).
 * @summary List Members
 */
export const listMembers = async (teamId: string, options?: Parameters<typeof apiRequest>[1]): Promise<Member[]> => {

  return apiRequest<Member[]>(getListMembersUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMembersQueryKey = (teamId: string,) => {
    return [
    `/api/v1/teams/${teamId}/members`
    ] as const;
    }


export const getListMembersQueryOptions = <TData = Awaited<ReturnType<typeof listMembers>>, TError = ErrorType<ErrorEnvelope>>(teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMembersQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMembers>>> = ({ signal }) => listMembers(teamId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMembersQueryResult = NonNullable<Awaited<ReturnType<typeof listMembers>>>
export type ListMembersQueryError = ErrorType<ErrorEnvelope>


export function useListMembers<TData = Awaited<ReturnType<typeof listMembers>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMembers>>,
          TError,
          Awaited<ReturnType<typeof listMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMembers<TData = Awaited<ReturnType<typeof listMembers>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMembers>>,
          TError,
          Awaited<ReturnType<typeof listMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMembers<TData = Awaited<ReturnType<typeof listMembers>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Members
 */

export function useListMembers<TData = Awaited<ReturnType<typeof listMembers>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMembersQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRemoveMemberUrl = (teamId: string,
    userId: string,) => {




  return `/api/v1/teams/${teamId}/members/${userId}`
}

/**
 * Remove a member, or leave when it is the caller.
 * @summary Remove Member
 */
export const removeMember = async (teamId: string,
    userId: string, options?: Parameters<typeof apiRequest>[1]): Promise<void> => {

  return apiRequest<void>(getRemoveMemberUrl(teamId,userId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveMemberMutationKey = () => ['removeMember'] as const;

export const getRemoveMemberMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeMember>>, TError,RemoveMemberMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof removeMember>>, TError,RemoveMemberMutationVariables, TContext> => {

const mutationKey = getRemoveMemberMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeMember>>, RemoveMemberMutationVariables> = (props) => {
          const {teamId,userId} = props ?? {};

          return  removeMember(teamId,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveMemberMutationResult = NonNullable<Awaited<ReturnType<typeof removeMember>>>

    export type RemoveMemberMutationError = ErrorType<ErrorEnvelope>
    export type RemoveMemberMutationVariables = {teamId: string;userId: string}

    /**
 * @summary Remove Member
 */
export const useRemoveMember = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeMember>>, TError,RemoveMemberMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeMember>>,
        TError,
        RemoveMemberMutationVariables,
        TContext
      > => {
      return useMutation(getRemoveMemberMutationOptions(options), queryClient);
    }
    export const getChangeMemberRoleUrl = (teamId: string,
    userId: string,) => {




  return `/api/v1/teams/${teamId}/members/${userId}`
}

/**
 * @summary Change Member Role
 */
export const changeMemberRole = async (teamId: string,
    userId: string,
    memberUpdate: MemberUpdate, options?: Parameters<typeof apiRequest>[1]): Promise<Member> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<Member>(getChangeMemberRoleUrl(teamId,userId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(memberUpdate)
  }
);}





export const getChangeMemberRoleMutationKey = () => ['changeMemberRole'] as const;

export const getChangeMemberRoleMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeMemberRole>>, TError,ChangeMemberRoleMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof changeMemberRole>>, TError,ChangeMemberRoleMutationVariables, TContext> => {

const mutationKey = getChangeMemberRoleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeMemberRole>>, ChangeMemberRoleMutationVariables> = (props) => {
          const {teamId,userId,data} = props ?? {};

          return  changeMemberRole(teamId,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangeMemberRoleMutationResult = NonNullable<Awaited<ReturnType<typeof changeMemberRole>>>
    export type ChangeMemberRoleMutationBody = MemberUpdate
    export type ChangeMemberRoleMutationError = ErrorType<ErrorEnvelope>
    export type ChangeMemberRoleMutationVariables = {teamId: string;userId: string;data: MemberUpdate}

    /**
 * @summary Change Member Role
 */
export const useChangeMemberRole = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeMemberRole>>, TError,ChangeMemberRoleMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeMemberRole>>,
        TError,
        ChangeMemberRoleMutationVariables,
        TContext
      > => {
      return useMutation(getChangeMemberRoleMutationOptions(options), queryClient);
    }
    export const getListTeamProductsUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}/products`
}

/**
 * Every live product of the team's live brands, by name, for every member: live's Product
 * menus (the library's, the AI Actors') list every brand's.
 * @summary List Team Products
 */
export const listTeamProducts = async (teamId: string, options?: Parameters<typeof apiRequest>[1]): Promise<ProductSummary[]> => {

  return apiRequest<ProductSummary[]>(getListTeamProductsUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTeamProductsQueryKey = (teamId: string,) => {
    return [
    `/api/v1/teams/${teamId}/products`
    ] as const;
    }


export const getListTeamProductsQueryOptions = <TData = Awaited<ReturnType<typeof listTeamProducts>>, TError = ErrorType<ErrorEnvelope>>(teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTeamProducts>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTeamProductsQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTeamProducts>>> = ({ signal }) => listTeamProducts(teamId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTeamProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTeamProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listTeamProducts>>>
export type ListTeamProductsQueryError = ErrorType<ErrorEnvelope>


export function useListTeamProducts<TData = Awaited<ReturnType<typeof listTeamProducts>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTeamProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTeamProducts>>,
          TError,
          Awaited<ReturnType<typeof listTeamProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTeamProducts<TData = Awaited<ReturnType<typeof listTeamProducts>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTeamProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTeamProducts>>,
          TError,
          Awaited<ReturnType<typeof listTeamProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTeamProducts<TData = Awaited<ReturnType<typeof listTeamProducts>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTeamProducts>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Team Products
 */

export function useListTeamProducts<TData = Awaited<ReturnType<typeof listTeamProducts>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTeamProducts>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTeamProductsQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






